export default __webpack_public_path__ + "static/media/WINGS-BNB.46581a03.svg";